import { useContext } from 'react';

import { AppLayoutContext, AppLayoutStateContext } from '@state/app/ui/AppLayoutContext';

export const useAppLayout = (): AppLayoutStateContext => useContext(AppLayoutContext);
